// extracted by mini-css-extract-plugin
export var circle = "Spinner-module--circle--0336e";
export var container = "Spinner-module--container--92d8f";
export var dash = "Spinner-module--dash--fb9b7";
export var rotator = "Spinner-module--rotator--1ba6b";